import { ComponentView } from "./component-view.model";
import { UserNotificationType } from "./user-notification-type.model";

export class SaveDataHandler<T = any> {
    worker: () => Promise<T>;
    componentView: ComponentView;
    navigateBack = false;
    navigateTo: string[];
    successNotificationType = UserNotificationType.toast;
    successTitle: string = null;
    successText: string = null;
    errorNotificationType = UserNotificationType.dialog;
    errorTitle: string = null;
    errorText: string = null;
    isSuccess: (result: T) => boolean = () => true;
    
    constructor(options: Partial<SaveDataHandler<T>>) {
        if (options != null) {
            Object.assign(this, options);
        }
    }

}